import React from "react";

import { MapEntity } from "@mapmycustomers/shared/types/entity";
import ActivitySuggestion from "@mapmycustomers/shared/types/entity/ActivitySuggestion";
import { convertGeoPointToLatLngLiteral } from "@mapmycustomers/shared/util/geo/GeoService";

import MultiEntityMap from "@app/component/map/MultiEntityMap";
import CenterMarker from "@app/component/map/primitives/CenterMarker";
import Circle from "@app/component/map/primitives/Circle";
import localSettings from "@app/config/LocalSettings";
import { METERS_IN_MILE } from "@app/util/consts";

import styles from "./Map.module.scss";

interface Props {
  distance: number;
  entities: MapEntity[];
  loading?: boolean;
  suggestion: ActivitySuggestion;
}

const Map: React.FC<Props> = ({ distance, entities, loading, suggestion }) => {
  const siUnits = localSettings.doesUseSiUnits();
  const center = convertGeoPointToLatLngLiteral(suggestion.geoPoint!) ?? { lat: 0, lng: 0 };
  return (
    <div className={styles.container}>
      <MultiEntityMap entities={entities} loading={loading} showInfoWindow>
        <Circle
          center={center}
          fitBounds
          radius={siUnits ? 1000 * distance : METERS_IN_MILE * distance}
        />
        <CenterMarker center={center} />
      </MultiEntityMap>
    </div>
  );
};

export default Map;
